angular.module('ecrd')
    .controller('EntityMenuGlobalNotesController', ['RecordQueriesService', 'StudyContext', function(RecordQueriesService, StudyContext){
        var vm = this;

        vm.notes = RecordQueriesService.getMetaInfo();

        vm.permission = {
            read: StudyContext.canWithQueries('read'),
            create: StudyContext.canWithQueries('create'),
            reply: StudyContext.canWithQueries('reply'),
            close: StudyContext.canWithQueries('close'),
        };
    }]);
